import { Compiler } from '@/dsl/compilers';
import type { UnifiedContext } from '../context';
import { toDSLContext } from '../context';

type HideMode = 'display' | 'opacity' | 'visibility';

const normalizeHideMode = (mode?: string): HideMode => {
  if (mode === 'opacity' || mode === 'visibility') return mode;
  return 'display';
};

const applyHideMode = (el: HTMLElement, mode: HideMode, hide: boolean) => {
  if (mode === 'opacity') {
    el.style.opacity = hide ? '0' : '';
    return;
  }

  if (mode === 'visibility') {
    el.style.visibility = hide ? 'hidden' : '';
    return;
  }

  el.style.display = hide ? 'none' : '';
};

export const handleHide = async (el: HTMLElement, ctx: UnifiedContext) => {
  const { storeHide, storeHideType } = el.dataset;
  if (!storeHide) return;

  const dslCtx = await toDSLContext(ctx);
  const hide = Compiler.boolean({ expr: storeHide, ctx: dslCtx });
  const mode = normalizeHideMode(storeHideType);

  applyHideMode(el, mode, hide);
};
